export const formatSLONumber = (value, fractionDigits = 1) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return "";

    const fixed = num.toFixed(fractionDigits);
    let [intPart, decPart] = fixed.split(".");

    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return decPart ? `${intPart},${decPart}` : intPart;
};

export const formatSLOPercent = (value, fractionDigits = 1) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return "-";

    return `${formatSLONumber(num * 100, fractionDigits) || "-"}%`;
};